export interface ShortFullNameParams {
    firstName?: string;
    lastName?: string;
}

export function formatShortFullName({ firstName, lastName }: ShortFullNameParams): string {
    return `${lastName || ''} ${firstName || ''}`;
}
